function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.235 2.68609C18.667 1.49109 17.509 0.33309 16.314 0.76609L1.70901 6.04809C0.510012 6.48209 0.365011 8.11809 1.46801 8.75709L6.13001 11.4561L10.293 7.29309C10.4816 7.11093 10.7342 7.01014 10.9964 7.01242C11.2586 7.01469 11.5094 7.11986 11.6948 7.30527C11.8802 7.49068 11.9854 7.74149 11.9877 8.00369C11.99 8.26589 11.8892 8.51849 11.707 8.70709L7.54401 12.8701L10.244 17.5321C10.882 18.6351 12.518 18.4891 12.952 17.2911L18.235 2.68609Z",
  fill: "currentColor"
});

var SvgPlaneFilled = function SvgPlaneFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaneFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane_filled.05a23822.svg";
export { ForwardRef as ReactComponent };